import Image from 'next/image';
import React, { Key } from 'react';

interface Props {
    title?: string;
    subtitle?: string;
    imageId?: Key;
    headerImageId?: Key;
    onPress?: () => any;
}

export const BaseTile: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({
    children,
    subtitle,
    title,
    imageId,
    headerImageId,
    onPress
}) => {
    return (
        <div
            className="tw-card-bordered tw-card-clickable tw-h-full tw-overflow-hidden tw-p-0"
            onClick={() => onPress?.()}
        >
            <div className="tw-relative tw-flex tw-min-h-[125px] tw-w-full tw-items-center tw-gap-4 tw-overflow-hidden tw-p-4">
                {imageId && (
                    <div className="tw-relative tw-z-10 tw-aspect-square tw-w-1/4 tw-overflow-hidden tw-rounded-full tw-border-4 tw-border-solid tw-border-white">
                        <Image
                            src={process.env.NEXT_PUBLIC_API_HOST + 'image/' + imageId}
                            layout="fill"
                            objectFit="cover"
                            alt={`${title}_logo`}
                        />
                    </div>
                )}
                {headerImageId && (
                    <Image
                        src={process.env.NEXT_PUBLIC_API_HOST + 'image/' + headerImageId}
                        layout="fill"
                        objectFit="cover"
                        alt={`${title}_header`}
                    />
                )}
            </div>
            <div className="tw-px-4 tw-pt-2">
                <h4 className="tw-mb-0 tw-truncate tw-font-medium">{title}</h4>
                {subtitle && <small className="tw-text-accents-6">{subtitle}</small>}
                <div className="tw-my-4">{children}</div>
            </div>
        </div>
    );
};
